import { createSafeJotaiSessionStorage } from '@/lib/jotai-storage';
import { ENV_NAME, getEnvironment } from '@heidi/api/config';
import { atomWithStorage } from 'jotai/utils';

/**
 * Seen-modals / `__heidiModals.forceShow` override for the Dictate-page tour
 * banner. The banner is not a queued modal — Force show cannot inject it into
 * `GlobalModalsWrapper` — so this atom is the bypass for hotkey+WAU retire.
 *
 * Session-scoped: a forgotten `true` should not survive the tab. Ignored in
 * production (see `DictationLogsContent`).
 */
export const dictateTourBannerDevForceShowAtom = atomWithStorage<boolean>(
  'heidi.devTools.dictateTourBanner.forceShow',
  false,
  createSafeJotaiSessionStorage<boolean>(),
  { getOnInit: true }
);

dictateTourBannerDevForceShowAtom.debugLabel = 'dictateTourBannerDevForceShowAtom';

export const isDictateTourBannerDevForceShowEnabled = (): boolean =>
  getEnvironment() !== ENV_NAME.PROD;
